module.exports = __webpack_public_path__ + "images/components/estimate_banners/link_with_image/products_left_sp_43cc6bee172581074887dc83fecdfcf0.svg";